import { SET_SHOP } from '../../api/appointment/appointment-draft.actions';
import { journeyStateActions } from '../../api';

export const clearSelectedFacets =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    if (action.type === SET_SHOP) {
      dispatch(journeyStateActions.clearSelectedFacets());
    }
  };
